import { accessAllTariffPlansList, accessStarterStandardAndLightPlansList } from 'constants/accessPlanLists';
import { IOnePageSections, ONE_PAGE_SECTIONS as S } from 'constants/businessToolSections/onePage';

import { ISectionAccess } from './interface';

type IAccessibilityRules = {
  [K in IOnePageSections]: ISectionAccess;
};

export const onePageAccessibilityRules: IAccessibilityRules = {
  [S.ABOUT_THE_COMPANY]: {
    _accessPlan: accessAllTariffPlansList,
  },
  [S.ABOUT_THE_PROJECT]: {
    _accessPlan: accessAllTariffPlansList,
  },
  [S.PRODUCTS_SERVICES]: {
    _accessPlan: accessAllTariffPlansList,
  },
  [S.MARKET_AND_SALES]: {
    _accessPlan: accessStarterStandardAndLightPlansList,
  },
  [S.TEAM]: {
    _accessPlan: accessStarterStandardAndLightPlansList,
  },
  [S.FINANCIAL_PROJECTIONS]: {
    _accessPlan: accessStarterStandardAndLightPlansList,
  },
  [S.FINANCING_NEEDS]: {
    _accessPlan: accessStarterStandardAndLightPlansList,
  },
  [S.IMPLEMENTATION_PLAN]: {
    _accessPlan: accessStarterStandardAndLightPlansList,
  },
};
